/**
 * Enhanced SurveySession Sync Status
 */
export enum SyncStatus {
  SYNCED = 'synced',
  DIRTY = 'dirty',
  SYNCING = 'syncing',
  ERROR = 'error',
}

export enum SurveySessionStatus {
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  TERMINATED = 'terminated',
  EXPIRED = 'expired',
}
export interface ISurveySession {
  // Primary Key (id) in DB is usually the sessionId in logic
  id: string;
  survey_id: number;
  session_status: SurveySessionStatus;
  current_page_id: number | undefined;
  survey_language: string;
  survey_version: number;

  // JSONB Fields
  jsn_responses: Record<string, any>;
  jsn_session_state: Record<string, any>;
  jsn_activity_order: any[];
  jsn_constructed_lists: Record<string, any>;
  jsn_oe_mapping: Record<string, any>;
  jsn_passive_media: any[];

  // System / Metadata Fields
  sys_survey_start_time: string;
  sys_survey_end_time?: string;
  sys_last_updated: string;
  sys_profile_identifier: string | null;
  sys_disposition_code: number | null;
  sys_survey_delivery_status: string | null;
  sys_jsn_device_data: Record<string, any>;

  // --- Sync/Local Properties (Not in SQL table, but used for RxDB/App Logic) ---
  updated_at: string;
  sync_status: SyncStatus;
  last_sync_time?: string;
}
